import { render, staticRenderFns } from "./RecordingView.vue?vue&type=template&id=5ca33925&scoped=true"
import script from "./RecordingView.vue?vue&type=script&lang=js"
export * from "./RecordingView.vue?vue&type=script&lang=js"
import style0 from "./RecordingView.vue?vue&type=style&index=0&id=5ca33925&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca33925",
  null
  
)

export default component.exports